import { put, call } from 'redux-saga/effects';
import { requestDictionary } from '../../requestUtil';
import { GET_ENTITY_INFO_SERVICE_URL } from '../../../api/lelyBackend/config';
import { getUuid } from '../../../components/Vector/mfrchart/Util';
import withLoading from '../../../sagas/loadingSaga';
import {
  getEntityInfoError,
  getEntityInfoSuccess,
} from '../../../reducers/entityInformationSlice';

export default function* getEntityInformation(api, action) {
  const { entityId } = action.payload;

  // eslint-disable-next-line func-names
  yield* withLoading(function* () {
    yield call(fetchEntityInfoFromApi, api, entityId);
  });
}

function* fetchEntityInfoFromApi(api, entityId) {
  const requestUuid = getUuid();
  requestDictionary[GET_ENTITY_INFO_SERVICE_URL] = requestUuid;
  try {
    const entityInfoData = yield call(api.getEntityInfo, entityId);
    if (requestDictionary[GET_ENTITY_INFO_SERVICE_URL] === requestUuid) {
      yield put(getEntityInfoSuccess(entityInfoData.data));
    }
  } catch (error) {
    if (requestDictionary[GET_ENTITY_INFO_SERVICE_URL] === requestUuid) {
      yield put(getEntityInfoError(error as string));
    }
  }
}
